import {
  BOOK_APPOINMENT_QUESTIONARE,
  STORE_APPOINMENT_FORM_DATA,
  ADD_FAMILY,
  EDIT_FAMILY,
  BOOKING_CONFIRMATION,
  BOOKING_UPDATE_CONFIRMATION,
  REQUEST_BOOKING_CONFIRM,
  RESET_BOOKING,
  GOTO_DASHBOARD,
  UPDATE_UPLOADED_FILES,
} from "./type";
import loginedApi from "../apis";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import moment from "moment";
import CryptoJS from "crypto-js";
import UAParser from "ua-parser-js";

var hashcode = CryptoJS.SHA256(
  process.env.REACT_APP_PREFIX +
    process.env.REACT_APP_TOKEN +
    process.env.REACT_APP_SECRETKEY
);

const publicIp = require("public-ip");
let IP = publicIp.v4();
const { detect } = require("detect-browser");
const browser = detect();

let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B");
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D");
} //replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

export const fetchPatientDetail = (data) => async (dispatch) => {
  console.log("data", data);
  //  let res = await loginedApi.post("getexistingpatient", );

  let params = {
    token: hashcode.toString(),
    data: {
      // patientNumber: "%2B" + data?.patientNumber,
      countryCode: data?.countryCode,
      browserTimeZone: `GMT${formatTime}`,
      useragent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
    },
    requestType: 2016,
  };

  if (data.email) {
    params.data.email = data.email;
  } else {
    params.data.patientNumber = "%2B" + (data?.patientNumber || "");
  }

  const res = await loginedApi.post("getexistingpatient", params);

  console.log(res);
  return res.data;
};

export const fetchclinicnames = () => async (dispatch) => {
  let res = await loginedApi.post("getclinicnames", {
    token: hashcode.toString(),
    data: {
      browserTimeZone: `GMT${formatTime}`,
      userAgent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
    },
    requestType: 2017,
  });
  console.log(res);
  return res.data.data;
};

export const fetchspecilaity = (doctorId) => async (dispatch) => {
  console.log("doctorId", doctorId);
  //   let res = await loginedApi.post("getspeciality", {
  //       token: hashcode.toString(),
  //       data: {
  //           doctorId: doctorId,
  //           browserTimeZone : `GMT${formatTime}`,
  //           userAgent : userAgent,
  //           Browser : browser.name + " " + browser.version,
  //           appname: "C2MD Web",
  //           Os: platform,
  //       },
  //       requestType: 507,

  //   });

  let res = await loginedApi.post("getspeciality", {
    token: hashcode.toString(),
    data: {
      doctorId: doctorId,
      browserTimeZone: `GMT${formatTime}`,
      userAgent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
    },
    requestType: 507,
  });
  console.log(res);
  return res.data.data;
};

export const fetchdoctor =
  ({ doctorId, clinicId, speciality }) =>
  async (dispatch) => {
    let res = await loginedApi.post("getdoctor", {
      token: hashcode.toString(),
      data: {
        doctorId: doctorId,
        clinicId: clinicId,
        speciality: speciality,
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform,
      },
      requestType: 508,
    });
    console.log(res);
    return res.data.data;
  };

export const fetchconsultation = (specialityId) => async (dispatch) => {
  console.log("doctorId", specialityId);
  let res = await loginedApi.post("getconsultation", {
    token: hashcode.toString(),
    data: {
      doctorId: specialityId,
      browserTimeZone: `GMT${formatTime}`,
      userAgent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
    },
    requestType: 1017,
  });
  const consultationData = res.data.data;
  console.log(res);
  return consultationData;
};

export const fetchtimezone = (doctorId) => async (dispatch) => {
  console.log("doctorId", doctorId);
  let res = await loginedApi.post("gettimezone", {
    token: hashcode.toString(),
    data: {
      doctorId: doctorId,
      browserTimeZone: `GMT${formatTime}`,
      userAgent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
    },
    requestType: 122,
  });
  console.log(res);
  return res.data.data;
};

export const bookingform =
  (formData, bookingType, bookedDetails) => async (dispatch) => {
    console.log(formData, bookingType, bookedDetails);

    let resp = await loginedApi.post("getcountrycode", {
      token :hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: `GMT${formatTime}` },
      requestType: 513,
    });
    const doctorscountrycode = resp.data.data;

    
    var hash = CryptoJS.SHA512("C2MD|Welcome@123");

    let password = hash.toString();

    let hashPassword = hash.toString(CryptoJS.enc.Base64);

    const parser = new UAParser();
    const osInfo = parser.getOS();
    const osVersion = osInfo.name + " " + osInfo.version.split(";")[0].trim();

    const patientNumber = formData.patientNumber?.number || formData.patientNumber;
    const phoneNumberOnly = patientNumber.replace('+', '');

    console.log('phoneNumberOnly',phoneNumberOnly)
    console.log('patientNumber',patientNumber)

    const payload = {
      token: hashcode.toString(),
      requestType: "513",
      version: "2.0",
      data: {
        browserTimeZone: `GMT${formatTime}`,
        accessCountry: doctorscountrycode.Country,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: osVersion,
        ModeofConsultation: "Video",
        isNewPatient: formData.isNewPatient,
        patientNumber: {
          dialCode: formData.patientNumber?.dialCode,
          number: formData.patientNumber?.number,
        },
       
        
        patientmobile: formData.patientNumber !== undefined ? "%2B" + phoneNumberOnly : '',
                
        password: password,
        patientemail: formData.email.toLowerCase(),
        patientname: formData.patientName,
        gender: formData.gender,
        dob: moment(formData.dob, "DD-MMM-YYYY").format("DD/MMM/YYYY"),
        clinic: formData.clinic,
        blockId: "",
        address: formData.address,
        speciality: formData.speciality,
        doctorId: formData.doctorId,
        TypeofConsultation: formData.typeOfConsultation,
        appoitmentdate: moment(formData.appointmentDate, "DD-MMM-YYYY").format(
          "DD-MMM-YYYY"
        ),
        appoitmenttime: formData.appointmentTime,
        fees: formData.consultationFees,
        paymentId: formData.paymentId,
        paymentMethod: formData.paymentMethod,
        reasonforbooking: formData.reasonForBooking,
        bookingType: bookingType,
        timezone: formData.timezone.replace("+", "%2B"),
        bookedDetails: bookedDetails,
      },
      
    };

    console.log("formData.patientNumber",formData.patientNumber)
    try {
      let res = await loginedApi.post("booking", payload);
      console.log(res);
      return res.data.data;
    } catch (error) {
      console.error("Error submitting form", error);
      throw error;
    }
  };

export const bookingformRequest =
  (formData, bookingType, bookedDetails) => async (dispatch) => {
    console.log(formData, bookingType, bookedDetails);

    let resp = await loginedApi.post("getcountrycode", {
      token :hashcode.toString(),
      version: "2.0",
      data: { browserTimeZone: `GMT${formatTime}` },
      requestType: 513,
    });
    const doctorscountrycode = resp.data.data;

    
    var hash = CryptoJS.SHA512("C2MD|Welcome@123");

    let password = hash.toString();

    let hashPassword = hash.toString(CryptoJS.enc.Base64);

    const parser = new UAParser();
    const osInfo = parser.getOS();
    const osVersion = osInfo.name + " " + osInfo.version.split(";")[0].trim();

    const patientNumber = formData.patientNumber?.number || formData.patientNumber;
    const phoneNumberOnly = patientNumber.replace('+', '');

    console.log('phoneNumberOnly',phoneNumberOnly)
    console.log('patientNumber',patientNumber)

    const payload = {
      token: hashcode.toString(),
      requestType: "513",
      version: "2.0",
      data: {
        browserTimeZone: `GMT${formatTime}`,
        accessCountry: doctorscountrycode.Country,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: osVersion,
        ModeofConsultation: "Video",
        isNewPatient: formData.isNewPatient,
        patientNumber: {
          dialCode: formData.patientNumber?.dialCode,
          number: formData.patientNumber?.number,
        },
       
        
        patientmobile: formData.patientNumber !== undefined ? "%2B" + phoneNumberOnly : '',
                
        password: password,
        patientemail: formData.email.toLowerCase(),
        patientname: formData.patientName,
        gender: formData.gender,
        dob: moment(formData.dob, "DD-MMM-YYYY").format("DD/MMM/YYYY"),
        clinic: formData.clinic,
        blockId: "",
        address: formData.address,
        speciality: formData.speciality,
        specialityId: formData.specialityId,
        TypeofConsultation: formData.typeOfConsultation,
        appoitmentdate: moment(formData.appointmentDate, "DD-MMM-YYYY").format(
          "DD-MMM-YYYY"
        ),
        appoitmenttime: formData.appointmentTime || "",
        fees: formData.consultationFees,
        paymentId: formData.paymentId,
        paymentMethod: formData.paymentMethod,
        reasonforbooking: formData.reasonForBooking,
        bookingType: bookingType,
        timezone: formData.timezone?.replace("+", "%2B") || "",
        bookedDetails: bookedDetails,
      },
      
    };

    console.log("formData.patientNumber",formData.patientNumber)
    try {
      let res = await loginedApi.post("bookrequest", payload);
      console.log(res);
      return res.data.data;
    } catch (error) {
      console.error("Error submitting form", error);
      throw error;
    }
  };

export const fetchPatientLovedOne = (email) => async (dispatch) => {
  let res = await loginedApi.post("addnew", {
    token: hashcode.toString(),
    data: {
      type: "email",
      value: email,
      browserTimeZone: `GMT${formatTime}`,
      userAgent: userAgent,
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      Os: platform,
    },
    requestType: 1031,
  });
  console.log(res);
  return res.data.data;
};

export const CheckuserEmailavailbility =
  ({ searchtype, searchKey, userType }) =>
  async (dispatch) => {
    const res = await loginedApi.post("getemaiavailability", {
      requestType: 10,
      token: hashcode.toString(),
      data: { userName: "User", emailId: searchKey, userType: "Patient" },
    });

    return res.data?.data;
  };

  export const getdoctorbyspeciality =
  ( speciality,clinicName ) =>
  async (dispatch) => {

    console.log("speciality",speciality)
    let res = await loginedApi.post("getdoctorbyspeciality", {
      token: hashcode.toString(),
      data: {
        clinicName:clinicName,
        specialityId: speciality,
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform,
      },
      requestType: 508,
    });
    console.log(res);
    return res.data.data;
  };